const SCRAMBLED_REG = /^\/?chats\/new(\/?[1-9]+)?\.(.*$)/i;
const NAMED_REG = /^\/?chats\/new(\/?[^1-9]+)?(\.?.*)$/i;
const CREATE_REG = /^\/?chats\/create(.*)$/i;
const chatsHandler = (url) => {
  if (SCRAMBLED_REG.test(url)) {
    return url.replace(SCRAMBLED_REG, "/messenger/chats/new$1");
  }
  if (NAMED_REG.test(url)) {
    return url.replace(NAMED_REG, "/messenger/chats/new$1$2");
  }
  if (CREATE_REG.test(url)) {
    return url.replace(CREATE_REG, "/messenger/chats/contacts$1");
  }
  return null;
};
export {
  chatsHandler
};
